import { Modal } from "antd";
import "./modal.scss"
export default Modal;
